const getCharBeforeSelection = (value: string, selectionStart: number): string => {
    let index = selectionStart - 1;

    while (value.charAt(index) === ' ') {
        index -= 1;
    }

    return value.charAt(index);
};

const SPECIAL_CHAR_REGEX = /^[=(,?*/^%&\-+<>;]$/;

export const hasSpecialCharBeforeSelection = (text: string, selectionStart: number): boolean => {
    const charBeforeSelection = getCharBeforeSelection(text, selectionStart);
    return !!(charBeforeSelection && charBeforeSelection.match(SPECIAL_CHAR_REGEX));
};
